import { render, staticRenderFns } from "./FixedQrCode.vue?vue&type=template&id=70adbc0c"
import script from "./FixedQrCode.vue?vue&type=script&lang=js"
export * from "./FixedQrCode.vue?vue&type=script&lang=js"
import style0 from "./FixedQrCode.vue?vue&type=style&index=0&id=70adbc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports